import { GetSubscriptionTermsConditions } from "../queries/GetSubscriptionTermsConditions.pim.js";
import { getSubscriptionVariantTermsConditions } from "../selectors/getSubscriptionVariantTermsConditions.js";
export const fetchSubscriptionTermsConditions = async (sku, { client }) => {
    const data = await client.pim.request(GetSubscriptionTermsConditions, {
        sku,
        tenantId: client.tenantId,
    });
    const subscription = data.product?.getVariants?.[0];
    if (!subscription) {
        throw new Error(`Could not find subscription item for sku: ${sku}`);
    }
    return getSubscriptionVariantTermsConditions(subscription);
};
